export default "__VITE_ASSET__BiN4VXFC__"